var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"m12.471 15.47 5.5-5.47 1.058 1.063-4.965 4.938 4.965 4.938-1.058 1.063-5.5-5.47a.75.75 0 0 1 0-1.063","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }